import type { ServerError } from '@apollo/client';
import type { ErrorHandler } from '@apollo/client/link/error';

import sessionDialogOpenSubject from 'AuthenticatedRoutesContainer/TokenWatcher/sessionDialogOpenSubject';
import { clearTokenAndReload } from 'common/helpers/authenticationHelper';

const errorHandler: ErrorHandler = ({
  response: executionResult,
  networkError,
  operation: { operationName = undefined, getContext },
}) => {
  const { response } = getContext();

  // Read the x-request-id response header and put it into the gql error's extension field
  if (executionResult && response) {
    const requestId = response.headers?.get('x-request-id');
    executionResult.errors = executionResult?.errors?.map(err => ({ ...err, extensions: { requestId } }));
  }

  if (networkError) {
    const { statusCode } = networkError as ServerError;

    switch (statusCode) {
      /**
       * If user is unauthenticated clear it's token from client side
       * and redirect it to root
       */
      case 401:
        /**
         * Here we ignore errors for exchangeToken mutation
         * In case when user have multiple tabs open, exchangeToken mutation is fired at the same time from all tabs.
         * Only one of those mutations can pass with current token, so in order to prevent user from logging out,
         * we ignore errors for exchangeToken
         * Operation name is hardcoded here, please update it together with the name of mutation for exchanging token
         */
        if (!sessionDialogOpenSubject.value && operationName !== 'exchangeToken') {
          clearTokenAndReload();
        }
        break;

      default:
        break;
    }
  }
};

export default errorHandler;
